var _excluded = ["bodyOpenClassName", "children", "contentLabel", "isOpen", "onAfterClose", "onRequestClose", "pointerAlignment", "pointerCustomValue", "shouldReturnFocusAfterClose", "useScopedStyles"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo } from 'react';
import ReactModal from 'react-modal';
import * as styles from "../styles/Popover.styles";
import { ModalWithScopedStyles } from "../../../../..";
import { Pointer } from "../../../../elements/Pointer/Pointer";
export var CLOSE_TIMEOUT_MS = 250;
var POPOVER_CONTENT_CLASS_NAMES = {
  base: 'popover-content',
  afterOpen: 'popover-content--afterOpen',
  beforeClose: 'popover-content--beforeClose'
};
var POPOVER_OVERLAY_CLASS_NAMES = {
  base: 'popover-overlay',
  afterOpen: 'popover-overlay--afterOpen',
  beforeClose: 'popover-overlay--beforeClose'
};
var PopoverGlobalStyles = styles.PopoverGlobalStyles({
  contentClassNames: POPOVER_CONTENT_CLASS_NAMES,
  overlayClassNames: POPOVER_OVERLAY_CLASS_NAMES,
  closeTimeoutMS: CLOSE_TIMEOUT_MS
});
var getCSSValue = function getCSSValue(value) {
  return value ? "".concat(value, "px") : 'auto';
};

/*
  The Popover component displays sub components within a modal. It can be provided
  dimensions and position props.
*/
export var Popover = function Popover(_ref) {
  var _props$dimensions3, _props$dimensions4, _props$position5, _props$position6, _props$position7, _props$position8;
  var bodyOpenClassName = _ref.bodyOpenClassName,
    children = _ref.children,
    contentLabel = _ref.contentLabel,
    isOpen = _ref.isOpen,
    onAfterClose = _ref.onAfterClose,
    onRequestClose = _ref.onRequestClose,
    pointerAlignment = _ref.pointerAlignment,
    pointerCustomValue = _ref.pointerCustomValue,
    shouldReturnFocusAfterClose = _ref.shouldReturnFocusAfterClose,
    useScopedStyles = _ref.useScopedStyles,
    props = _objectWithoutProperties(_ref, _excluded);
  var contentStyle = useMemo(function () {
    var _props$dimensions, _props$dimensions2, _props$position, _props$position2, _props$position3, _props$position4;
    return {
      content: {
        width: getCSSValue((_props$dimensions = props.dimensions) === null || _props$dimensions === void 0 ? void 0 : _props$dimensions.width),
        height: getCSSValue((_props$dimensions2 = props.dimensions) === null || _props$dimensions2 === void 0 ? void 0 : _props$dimensions2.height),
        top: getCSSValue((_props$position = props.position) === null || _props$position === void 0 ? void 0 : _props$position.top),
        bottom: getCSSValue((_props$position2 = props.position) === null || _props$position2 === void 0 ? void 0 : _props$position2.bottom),
        left: getCSSValue((_props$position3 = props.position) === null || _props$position3 === void 0 ? void 0 : _props$position3.left),
        right: getCSSValue((_props$position4 = props.position) === null || _props$position4 === void 0 ? void 0 : _props$position4.right)
      }
    };
  }, [(_props$dimensions3 = props.dimensions) === null || _props$dimensions3 === void 0 ? void 0 : _props$dimensions3.height, (_props$dimensions4 = props.dimensions) === null || _props$dimensions4 === void 0 ? void 0 : _props$dimensions4.width, (_props$position5 = props.position) === null || _props$position5 === void 0 ? void 0 : _props$position5.bottom, (_props$position6 = props.position) === null || _props$position6 === void 0 ? void 0 : _props$position6.left, (_props$position7 = props.position) === null || _props$position7 === void 0 ? void 0 : _props$position7.right, (_props$position8 = props.position) === null || _props$position8 === void 0 ? void 0 : _props$position8.top]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopoverGlobalStyles, null), /*#__PURE__*/React.createElement(ModalWithScopedStyles, {
    ariaHideApp: false,
    bodyOpenClassName: bodyOpenClassName,
    className: POPOVER_CONTENT_CLASS_NAMES,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    contentLabel: contentLabel,
    isOpen: isOpen,
    onAfterClose: onAfterClose,
    onRequestClose: onRequestClose,
    overlayClassName: POPOVER_OVERLAY_CLASS_NAMES,
    shouldReturnFocusAfterClose: shouldReturnFocusAfterClose,
    style: contentStyle,
    useScopedStyles: useScopedStyles
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(Pointer, {
    alignment: pointerAlignment,
    pointerCustomLeftValue: pointerCustomValue
  }))));
};
export var setPopoverAppElement = ReactModal.setAppElement;